import { SideMobileMenuButton } from './SideMobileMenuButton';

const upperMobileMenuButtons = [
  {
    link: '/welcomeBack',
    name: 'Start',
  },
  {
    link: '/preferences',
    name: 'Preferences',
  },
  {
    link: '/tour',
    name: 'Tour',
  },
  {
    link: '/updatePws',
    name: 'Password',
  },
];

const lowerMobileMenuButtons = [
  {
    link: '/feedback',
    name: 'Feedback',
  },
  {
    link: '/logout',
    name: 'Logout',
  },
];

export const SideMobileMenuContent = () => {
  return (
    <div className="flex h-screen flex-col justify-between overflow-y-hidden">
      <div className="flex flex-col gap-[13px] px-[9px] pt-[58px]">
        {upperMobileMenuButtons.map((btn) => {
          return <SideMobileMenuButton key={btn.name} sideMenuButtonAttributes={btn} />;
        })}
      </div>
      <div className="mb-14 flex flex-col gap-[13px] px-[9px]">
        {lowerMobileMenuButtons.map((btn) => {
          return <SideMobileMenuButton key={btn.name} sideMenuButtonAttributes={btn} />;
        })}
      </div>
    </div>
  );
};
